import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slot-overview',
  templateUrl: './slot-overview.component.html',
  styleUrls: ['./slot-overview.component.scss']
})
export class SlotOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
